<template>
	<div class="site-wrapper" :class="{ 'loading-blur': loading }">
		<div class="site-content">

			<div class="page">
				<div class="page__header">
					<div class="page__container">
						<h1 class="page__title">
							{{ t('page.title.account') }}
						</h1>
					</div>
				</div><!-- /.page__header -->
				<div class="page__content account__content">
					<div class="account__page__nav__panel">
						<ul class="account__page__nav__panel__list">
							<li class="account__page__nav__panel__list__item" :class="{ 'is-active': routeName === pageName(page) }" :key="pageName(page)" v-for="page in userRoutes">
								<router-link :to="{name: pageName(page)}">{{ t('nav.user.' + pageName(page).toLowerCase()) }}</router-link>
							</li>
						</ul>
					</div>
					<div class="page__container pt-4">
						<router-view></router-view>
					</div>
				</div><!-- /.page__content -->
			</div><!-- /.page -->
			<modal v-if="changeAvailable && initialModal" @close="initialModal = false">
				<div slot="body" >
					<h1 v-html="t('popup.userdata.first.time.title')" class="text-center">

					</h1>

					<div class="text-center" v-html="t('popup.userdata.first.time.content')">

					</div>
				</div>
				<div class="row justify-content-center" slot="footer">
					<div class="col-6 col-lg-3 d-flex justify-content-center">
						<button @click="initialModalClick" class="btn btn-primary">
							{{ t('popup.userdata.first.time.btn.ok')}}
						</button>
					</div>
				</div>
			</modal>
		</div>
		<aside-prefooter :prefooter="true"></aside-prefooter>
	</div>
</template>
<script>

	import Vuex from 'vuex';
	import AsidePrefooter from '@/components/layout/AsidePrefooter';
	import store from '@/store'
	import UserPages from '@/router/user';
	import Modal from '@/components/parts/modal';

	export default {
		name: 'UserPage',
		beforeRouteEnter(to, from, next) {

			store.dispatch('userRefreshAction').then(()=>{
				if(store.getters.getUserStatus){
					//next();
					store.dispatch('userDataAction').then(()=>{
						next();
					})

				}else{
					next({name: 'Auth', query: {redirect: to.fullPath}});
				}

			}).catch(function () {
				next({name: 'Auth', query: {redirect: to.fullPath}});
			})

		},
		data() {
			return {
				initialModal: false,
				loading: false
			}
		},
		components: {
			AsidePrefooter,
			Modal,
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				user: 'getUser',
				userLogedIn: 'getUserStatus'
			}),
			userRoutes(){
				return UserPages;
			},
			routeName(){
				return this.$route.name;
			},
			changeAvailable(){
				//return  /*this.user['customerstatus_id'] === 0 &&*/ ( !this.user.identity_upload_status || !this.user.bank_account_upload_status ); //PMCLNL-447
				return (!this.user.image_upload_completed || !this.user.bankaccountstatus);
			}
		},
		watch: {
			userLogedIn(val) {
				if (!val) {
					this.$router.replace('/'); //Go home, if user logout
				}
			}
		},
		mounted() {
			if(this.changeAvailable){
				this.initialModal = true;
			}

		},
		methods: {
			initialModalClick(){

				this.initialModal = false;
				this.$router.push({ name: 'UserData' });
			},
         pageName(page){

            if(page.hasOwnProperty('name')){
               return page.name
            }else if(page.hasOwnProperty('children') && page.children.length > 0){
               return page.children[0].name
            }
         }

		}
	}
</script>
